export default __webpack_public_path__ + "static/media/StandGuyHouse.4ee2584e.svg";